// extracted by mini-css-extract-plugin
var _1 = "ChatroomMessageLinkedRequests-modulechatroomMessageLinkedRequests__vEWuC";
var _2 = "ChatroomMessageLinkedRequests-moduletag___WBoN RequestTag-moduleRequestTag__INw7t Tag-moduleTag__FLr9H";
export { _1 as "chatroomMessageLinkedRequests", _2 as "tag" }
